export default __webpack_public_path__ + "static/media/loading-character.bdd3f45c.png";